// Translations
import form from '../sections/form/translations/en'

// Translation: Login > Landing (English)
export default Object.freeze({
	sections: { form }
})
